import React, { createContext, useState,useEffect } from 'react';

export const BookmarkedContext = createContext();

export const BookmarkedProvider  = ({ children }) => {
    const [bookmarkedItems, setBookmarkedItems] = useState(() => {
        const savedItems = localStorage.getItem('bookmarkedItems');
        return savedItems ? JSON.parse(savedItems) : [];
    });

    useEffect(() => {
        localStorage.setItem('bookmarkedItems', JSON.stringify(bookmarkedItems));
    }, [bookmarkedItems]);

    const addBookmark = (item) => {
        setBookmarkedItems((prevItems) => [...prevItems, item]);
    };
    const removeBookmark = (itemId) => {
        setBookmarkedItems((prevItems) =>
            prevItems.filter((item) => item.id !== itemId)
        );
    };

     const isBookmarked = (itemId) => {
        return bookmarkedItems.some((item) => item.id === itemId);
    };

    return (
        <BookmarkedContext.Provider
            value={{ bookmarkedItems, addBookmark, removeBookmark, isBookmarked }}
        >
            {children}
        </BookmarkedContext.Provider>
    );
}